

import axios from "axios";
import toast from "react-hot-toast";

// Fetch Task Titles
export const FETCH_TASK_TITLES_REQUEST = "FETCH_TASK_TITLES_REQUEST";
export const FETCH_TASK_TITLES_SUCCESS = "FETCH_TASK_TITLES_SUCCESS";
export const FETCH_TASK_TITLES_FAILURE = "FETCH_TASK_TITLES_FAILURE";

// Create Task Title
export const CREATE_TASK_TITLE_REQUEST = "CREATE_TASK_TITLE_REQUEST";
export const CREATE_TASK_TITLE_SUCCESS = "CREATE_TASK_TITLE_SUCCESS";
export const CREATE_TASK_TITLE_FAILURE = "CREATE_TASK_TITLE_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Fetch All Task Titles
export const fetchTaskTitles = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TASK_TITLES_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/get-all-tasks-admin`,
        { headers: { Authorization: token } }
      );

      if (response?.data?.meta?.status) {
        dispatch({
          type: FETCH_TASK_TITLES_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: FETCH_TASK_TITLES_FAILURE,
          payload: response.data?.meta?.message || "Failed to fetch task titles.",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_TASK_TITLES_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
    }
  };
};

// Create Task Title
export const createTaskTitle = (title, description, priority = "high") => {
  return async (dispatch) => {
    dispatch({ type: CREATE_TASK_TITLE_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/create-task`,
        { title, description, priority },
        { headers: { Authorization: token, "Content-Type": "application/json" } }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: CREATE_TASK_TITLE_SUCCESS });
        toast.success("Task Title Created Successfully");

        // Optionally refetch updated titles
        dispatch(fetchTaskTitles());
      } else {
        dispatch({
          type: CREATE_TASK_TITLE_FAILURE,
          payload: response.data?.meta?.message || "Failed to create task title.",
        });
        toast.error(response.data?.meta?.message || "Failed to create task title");
      }
    } catch (error) {
      dispatch({
        type: CREATE_TASK_TITLE_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error(error.response?.data?.meta?.message || "Error occurred");
    }
  };
};
